module.exports = __webpack_public_path__ + "images/icons_v2/objection-handling-0f403244.svg";